import moment from 'moment';

import {
  MEDICAL_DIAGNOSIS_YEAR_MAX,
  MEDICAL_DIAGNOSIS_YEAR_MIN,
} from './constants';

import type {
  ITreatmentPlanV3MedicalDiagnosis,
  TreatmentPlanV3MedicalDiagnosisPayload,
} from '../../../../../../store/treatmentPlanV3';
import type { MedicalDiagnosisFormValues } from '../types';

export function mapMedicalDiagnosisRowToValues(
  row: ITreatmentPlanV3MedicalDiagnosis,
): MedicalDiagnosisFormValues {
  return {
    diagnosis_name: row.diagnosis_name ?? '',
    provider_name: row.provider_name ?? '',
    city: row.city ?? '',
    state: row.state ?? '',
    year:
      row.year == null
        ? null
        : moment({ year: row.year, month: 0, date: 1 }),
  };
}

export function toMedicalDiagnosisFieldPayload(
  name: keyof MedicalDiagnosisFormValues,
  values: MedicalDiagnosisFormValues,
): TreatmentPlanV3MedicalDiagnosisPayload {
  if (name === 'year') {
    return { year: values.year?.year() ?? null };
  }
  return { [name]: values[name] };
}

export function getMedicalDiagnosisLabel(row: ITreatmentPlanV3MedicalDiagnosis): string {
  const diagnosis = row.diagnosis_name ?? 'New diagnosis';
  const provider = row.provider_name?.trim();
  return provider ? `${diagnosis} - ${provider}` : diagnosis;
}

export function getMedicalDiagnosisDeleteMessage(row: ITreatmentPlanV3MedicalDiagnosis): string {
  return `You are about to delete diagnosis "${row.diagnosis_name ?? ''}"`;
}

export function isMedicalDiagnosisYearValid(year: number): boolean {
  return Number.isInteger(year) && year >= MEDICAL_DIAGNOSIS_YEAR_MIN && year <= MEDICAL_DIAGNOSIS_YEAR_MAX;
}
